export const DEFAULT_LOCALE = 'en';
export const DEFAULT_LOCALE_NAME = 'English';

export interface SupportedLanguage {
    isoCode: string;
    language: string;
    country: string;
}

export const SUPPORTED_LANGUAGES: SupportedLanguage[] = [
    { isoCode: 'en', language: 'English', country: 'US' },
    { isoCode: 'es', language: 'Spanish', country: 'ES' },
    { isoCode: 'fr', language: 'French', country: 'FR' },
    { isoCode: 'de', language: 'German', country: 'DE' },
    { isoCode: 'it', language: 'Italian', country: 'IT' },
    { isoCode: 'pt', language: 'Portuguese', country: 'PT' },
    { isoCode: 'ru', language: 'Russian', country: 'RU' },
    { isoCode: 'zh', language: 'Chinese', country: 'CN' },
    { isoCode: 'ja', language: 'Japanese', country: 'JP' },
    { isoCode: 'ko', language: 'Korean', country: 'KR' },
];

export function getLanguageByCode(code: string): SupportedLanguage | undefined {
    return SUPPORTED_LANGUAGES.find(lang => lang.isoCode === code);
}

interface CookieReader {
    get(name: string): { value: string } | undefined;
}

/**
 * Display name for SSR `?language=` fetches. The client stores the publisher's
 * own name (e.g. 日本語) in NEXT_LOCALE_NAME, which is what the backend keys
 * translations by; the static table only covers a first visit without it.
 */
export function resolveLanguageDisplayName(cookieStore: CookieReader): string | undefined {
    const storedName = cookieStore.get('NEXT_LOCALE_NAME')?.value;
    if (storedName) {
        return storedName;
    }
    const localeIso = cookieStore.get('NEXT_LOCALE')?.value;
    if (!localeIso) {
        return undefined;
    }
    return getLanguageByCode(localeIso)?.language;
}

export function isValidLocale(code: string): boolean {
    return SUPPORTED_LANGUAGES.some(lang => lang.isoCode === code);
}

export function detectBrowserLanguage(): string {
    if (typeof window === 'undefined') return DEFAULT_LOCALE;

    const browserLang = navigator.language || (navigator as any).userLanguage;
    const langCode = browserLang.split('-')[0].toLowerCase();

    return isValidLocale(langCode) ? langCode : DEFAULT_LOCALE;
}

